












































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FileOpen from '@/commonComponents/fileOpen/fileOpen.vue';
// import SelectPattern from './selectPattern/selectPattern.vue';
// import SelectLine from './selectLine/selectLine.vue';
import AlertModal from "@/commonComponents/alertModal/alertModal.vue";
import DeletePageModal from "@/commonComponents/alertModal/deletePageModal/deletePageModal.vue";
import SelectSaveStorageModal from "@/commonComponents/alertModal/selectSaveStorageModal/selectSaveStorageModal.vue";

import * as def from '@/definitions'
import { Const } from '@/const'
// TODO document2
import { Document } from '@/model/document2/document'

//ズームバー用のモジュール
import { UndoRedoManager } from '@/utilityModels/undoRedoManager';

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

// ボタン
import Save from "./resources/save.vue";
import CopyVertical from "./resources/copyVertical.vue";
import CopyHorizontal from "./resources/copyHorizontal.vue";
import CopyAll from "./resources/copyAll.vue";
import PageAdd from "./resources/pageAdd.vue";
import PageDelete from "./resources/pageDelete.vue";
import DeleteAll from "./resources/deleteAll.vue";
import DeleteUnselect from "./resources/deleteUnselect.vue";
import Delete from "./resources/delete.vue";
import UndoOn from "./resources/undoOn.vue";
import UndoOff from "./resources/undoOff.vue";
import RedoOn from "./resources/redoOn.vue";
import RedoOff from "./resources/redoOff.vue";
import ZoomMinus from "./resources/zoomMinus.vue";
import ZoomPlus from "./resources/zoomPlus.vue";
import ZoomValue from "./resources/zoomValue.vue";
import AutomaticMode from "./resources/automaticMode.vue";
import Automatic from "./resources/automatic.vue";
import RadioOn from "./resources/radioOn.vue";
import RotateSurfaceButton from "./resources/rotateSurfaceButton.vue";

import { DebugHelper } from "@/helper/debugHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import RangeSlider from '@/components/VRangeSliderZoom.vue';

@Component({
  components: {
    RangeSlider,
    AlertModal,
    DeletePageModal,
    SelectSaveStorageModal,
    ValueEdit,

    Save,
    CopyVertical,
    CopyHorizontal,
    CopyAll,
    PageAdd,
    PageDelete,
    DeleteAll,
    DeleteUnselect,
    Delete,
    UndoOn,
    UndoOff,
    RedoOn,
    RedoOff,
    ZoomMinus,
    ZoomPlus,
    ZoomValue,
    AutomaticMode,
    Automatic,
    RadioOn,
    RotateSurfaceButton
  },
})
export default class TopController extends Vue {

    @Prop() private document! : Document;
    @Prop() private maxPage! : number;
    @Prop() private zoomScale! : number;
    @Prop() private isAutoZoom! : boolean;

    private static readonly ZOOM_SCALE_MIN = Const.CANVAS_ZOOM_MIN;
    private static readonly ZOOM_SCALE_MAX = Const.CANVAS_ZOOM_MAX;
    private static readonly ZOOM_SCALE_DELTA = 25;

    private get zoomMin() { return TopController.ZOOM_SCALE_MIN; }
    private get zoomMax() { return TopController.ZOOM_SCALE_MAX; }

    alertModalShown = false;
    deletePageModalShown = false;
    selectStorageModalShown = false;
    upperLimitTitle = "ページ数が上限を超えました";
    upperLimitMessage = "ページ数が上限を超えたため、これ以上追加できません。";

    // アンドゥリドゥ管理クラス取得
    private get undoRedoManager() : UndoRedoManager { return this.document.undoRedoManager; }

    // UndoRedoの表示制御
    private get canUndo() : boolean { return this.document.undoRedoManager.canUndo; }
    private get canRedo() : boolean { return this.document.undoRedoManager.canRedo; }

    // 表裏表示制御
    private get canReverse() { return this.document.hasReverseSurface; }
    private get isDisplayBack() { return this.document.isReverseSurface; }

    // スライダー
    private get zoomScaleSliderValue() { return this.zoomScale; }
    private set zoomScaleSliderValue(zoomScaleSliderValue) { this.onDoCommand("changeZoomScale", { scale :zoomScaleSliderValue, isAutoZoomOff : true }); }

    private get isDebugMode(){
        return DebugHelper.isDebugMode;
    }

    private get isElectron()
    {
        return UserAgentHelper.isElectron();
    }

    private onDoCommand(command : string, paramater : any)
    {
        this.$emit("doCommand", command, paramater);
    }

    // ドキュメント保存
    private onClickSaveDocumentButton()
    {
        this.onDoCommand("saveDocument", null);
    }

    // 表面
    private onClickDisplaySurface()
    {
        this.onDoCommand("changeSurface", { isReverse : false });
    }

    // 裏面
    private onClickDisplayBack()
    {
        this.onDoCommand("changeSurface", { isReverse : true });
    }

    // アンドゥ
    private onClickUndoButton()
    {
        this.onDoCommand("undo", null);
    }

    // リドゥ
    private onClickRedoButton()
    {
        this.onDoCommand("redo", null);
    }

    // 縦一列コピー
    onClickCopyVerticalButton()
    {
        this.onDoCommand("copyVertical", null);
    }

    // 横一列コピー
    onClickCopyHorizontalButton()
    {
        this.onDoCommand("copyHorizontal", null);
    }

    // 全面コピー
    onClickCopyAllButton()
    {
        this.onDoCommand("copyAll", null);
    }

    // 1面削除
    onClickDeleteButton()
    {
        this.onDoCommand("deleteDesign", null);
    }

    // 選択外削除
    onClickDeleteUnselectButton()
    {
        this.onDoCommand("deleteUnselect", null);
    }

    // 全面削除
    onClickDeleteAllButton()
    {
        this.onDoCommand("deleteAll", null);
    }

    // ページ追加
    onClickPageAddButton()
    {
        if(this.maxPage >= Const.MAX_PAGE_NUMBER){
            this.alertModalShown = true;
            return;
        }
        this.onDoCommand("addPage", null);
    }

    // ページ削除
    onClickPageDeleteButton()
    {
        // 1ページしかないときは何もしない
        if(this.document.pageList.length <= 1) { return; }
        // モーダル表示
        this.deletePageModalShown = true
    }

    deletePage()
    {
        this.onDoCommand("deletePage", null);
    }

    // 回転
    private onRotateSurface()
    {
        this.onDoCommand("rotateDocument", {delta : 90});
    }

    // 塗り足し
    private get maxBleedSize() { return Const.BLEED_SIZE_MAX; }
    private get bleedSize() { return this.$store.getters.userConfig.bleedSize; }
    private setBleedSize(value: number, tag: string)
    {
        this.onDoCommand("changeUserConfig", { propertyName : tag, value : value });
    }

    // ズーム
    private decreaseZoomScale()
    {
        // 今のzoomScaleより小さく適切な値を求める
        var newValue = TopController.ZOOM_SCALE_MAX;
        while(newValue >= TopController.ZOOM_SCALE_MIN)
        {
            if(newValue < this.zoomScale) { break; }
            newValue -= TopController.ZOOM_SCALE_DELTA;
        }
        if(this.zoomScale != newValue && newValue >= TopController.ZOOM_SCALE_MIN)
        {
            this.onDoCommand("changeZoomScale", { scale : newValue, isAutoZoomOff : true });
        }
    }

    private increaseZoomScale()
    {
        // 今のzoomScaleより大きく適切な値を求める
        var newValue = TopController.ZOOM_SCALE_MIN;
        while(newValue <= TopController.ZOOM_SCALE_MAX)
        {
            if(newValue > this.zoomScale) { break; }
            newValue += TopController.ZOOM_SCALE_DELTA;
        }
        if(this.zoomScale != newValue && newValue <= TopController.ZOOM_SCALE_MAX)
        {
            this.onDoCommand("changeZoomScale", { scale : newValue, isAutoZoomOff : true });
        }
    }

    private changeAutoZoom()
    {
        this.onDoCommand("changeAutoZoom", { isAutoZoom : !this.isAutoZoom });
    }

    //ズームバー
    speechBaloon = false;

    //ズームバーの吹き出し
    private get zoomSpeechBalloon(){
        let range = (1000 - this.zoomScale) / 475 + "%";

        let distance = "calc(" + this.zoomScale / 10 + "% - 22.5% - " + range + ")";
        var style = {
            position: "absolute",
            left: distance,
            top: "-70%",
            width: "45%",
            height: "70%",
            display: "flex",
            "align-items": "center",
            "justify-content": "center"
        };
        return style;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigDarkColor(){
        return this.$store.getters.userConfigColors.darkButtonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }
}
